module.exports = __webpack_public_path__ + "img/w3_rocket_light.7491e432.png";